import type { AgentChatMessage } from "../../types";
import ConceptCard from "./ConceptCard";

/** A concept card row of the thread; its `stale` and `chosen` marks are on the row. */
const ConceptMessage = ({ message }: { message: AgentChatMessage }) =>
  message.concept ? <ConceptCard data={message.concept} /> : null;

export default ConceptMessage;
